declare namespace $ {

	export class $shm_hitalama_map_widget_float_code_ts extends $shm_hitalama_map_widget_float_code_js {
		textarea_hint( ): string
	}
	
}

//# sourceMappingURL=ts.view.tree.d.ts.map